var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeprecatedX = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FF1E39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.066 7 1.59-1.59a.476.476 0 0 0 .144-.35.53.53 0 0 0-.143-.367l-.35-.35A.53.53 0 0 0 8.94 4.2a.476.476 0 0 0-.35.143L7 5.934l-1.59-1.59a.476.476 0 0 0-.35-.144.53.53 0 0 0-.367.143l-.35.35a.531.531 0 0 0-.143.366c0 .138.048.255.143.35L5.934 7l-1.59 1.591a.476.476 0 0 0-.144.35c0 .138.048.26.143.366l.35.35a.53.53 0 0 0 .366.143.476.476 0 0 0 .35-.143L7 8.067l1.59 1.59a.476.476 0 0 0 .35.143.53.53 0 0 0 .367-.143l.35-.35a.53.53 0 0 0 .143-.366.476.476 0 0 0-.143-.35l-1.591-1.59Z",
    fill: "#fff"
  })));
};
export default SvgDeprecatedX;